module.exports = __webpack_public_path__ + "img/zeev-pro.0ab18d49.jpg";